<app-ibase-crud-content
    [deleteRenforced]="true"
    [showHelpButton]="true"
    [defaultPaginatorConfig]="CpmCUserRoleApiService.dPaginatorConfig"
></app-ibase-crud-content>

<!-- BUGFIX: p-message disapear on modal close, making DOM dialog dynamic fix it -->
@if (helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <div>
            <p>This component allow you to create and manage user roles</p>

            <p-table [value]="userRoleTypeTags" stripedRows showGridlines [tableStyle]="{'min-width': '50rem'}">
                <ng-template #header>
                    <tr>
                        <th [ngStyle]="{'text-align': 'center'}"><b>User Type</b></th>
                        <th><b>Permissions / Description</b></th>
                    </tr>
                </ng-template>
                <ng-template #body let-current>
                    <tr>
                        <td [ngStyle]="{'text-align': 'center'}">
                            <p-tag [style]="current.style" [value]="current.label" [rounded]="false"></p-tag>
                        </td>
                        <td>{{ current.tooltip }}</td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="p-dialog-footer">
                <p-button
                    severity="secondary"
                    icon="pi pi-times"
                    type="button"
                    label="Close"
                    (click)="helpVisible = false"
                />
            </div>
        </div>
    </p-dialog>
}
